export function convertToCurrency(amount) {
  var convertedAmount =  Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount)
  return convertedAmount;
}

export function convertToDisplayDate(date) {
  var convertedDate;
  if (date) {
    var interimDate = new Date(date);
    convertedDate = Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(interimDate);
  }

  return convertedDate;
}

export function updateTableRow(tableData, rowId, fieldName, fieldValue) {
  //get the row
  for (var i = 0; i < tableData.length; i++) {
    var row = tableData[i];
    if (row['id'] === rowId) {
      break;
    }
    //Do something
  }
  row[fieldName] = fieldValue
  tableData[i] = row
  return tableData
}

export function getMonthNameFromDate(date) {
  const monthNames = ["Jan", "Feb", "March", "April", "May", "June",
    "July", "Aug", "Sept", "Oct", "Nov", "Dec"
  ];
  const [year, month, day ] = date.split("-")
  const dateObject = new Date(year, month - 1, day)

  return monthNames[dateObject.getMonth()];
}

export function calculatePercent(firstNumber, secondNumber) {
  var changePercent
  changePercent = (((firstNumber - secondNumber)/secondNumber) * 100).toFixed(2)
  if (changePercent === 'Infinity') {
    changePercent = 100.00
  } else if (isNaN(changePercent)) {
    changePercent = 0.00
  }
  return changePercent
}